<style >

</style>
<template>
  <div>
    <Row >
      <Table :data="list" :columns="cloumn">

         <template slot-scope="{ row, index }" slot="action" >
              <Dropdown trigger="click" style="margin-left: 20px" :transfer="true">
              <a href="javascript:void(0)">
            操作列表
            <Icon type="ios-arrow-down"></Icon>
        </a>
        <DropdownMenu slot="list"  >
            <DropdownItem >
               <Button
              type="primary"
              v-if="row.entryUserId==$store.state.user.userId"
              @click="update(row)"
            >更新</Button>
            </DropdownItem>
            <DropdownItem> <Button
              type="error"
               v-if="row.entryUserId==$store.state.user.userId"
              @click="deleteProject(row)"
            >删除</Button></DropdownItem>
        </DropdownMenu>
    </Dropdown>
          </template>
          <template slot="maluation"  slot-scope="{ row, index }">
            <Poptip trigger="hover" word-wrap width="300" :content="row.maluation"  :transfer="true">
                 <a>查看</a>
            </Poptip>
          </template>
      </Table>
    </Row>
     <Modal
      v-model="updateRProjectModal"
      :width="800"
      :scrollable="true"
      title="更新项目信息"
      :mask="true"
      :mask-closable="false"
    >
      <addProject ref="projectInfo"></addProject>
      <div slot="footer">
        <Button type="primary" long :loading="addLoading" @click="saveRProject">保存</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import addProject from "./addProject";
import project from "@/api/project.js";
export default {
    components: {
    addProject,
  },
  props: {
    id: String
  },
  data() {
    return {
      projectId:'',
      addLoading:false,
      updateRProjectModal:false,
        count:0,
        list:[],
        query:{
            resourceId:'',
            page:1,
            size:20,
        },
      cloumn: [
        {
          title: "项目名称",
          key: "projectName",
          align: "center"
        },
        {
          title: "开始时间",
          key: "startTime",
          align: "center",
            render: function(h, params) {
            if (this.row.inTime) {
              //时区处理
              var localDate = new Date(this.row.inTime);
              var localTime = localDate.getTime();
              var localOffset = localDate.getTimezoneOffset() * 60 * 1000;

              return h(
                "div",
                new Date(localTime + localOffset).toLocaleDateString()
              );
            }
          }
        },
        {
          title: "结束时间",
          key: "endTime",
          align: "center",
            render: function(h, params) {
            if (this.row.inTime) {
              //时区处理
              var localDate = new Date(this.row.inTime);
              var localTime = localDate.getTime();
              var localOffset = localDate.getTimezoneOffset() * 60 * 1000;

              return h(
                "div",
                new Date(localTime + localOffset).toLocaleDateString()
              );
            }
          }
        },
        {
          title: "项目经理",
          key: "manager",
          align: "center"
        },
          {
          title: "项目状态",
          key: "status",
          align: "center"
        },
         {
          title: "承包量",
          key: "amount",
          align: "center"
         },
          {
          title: "效率",
          key: "efficiency",
          align: "center"
        },
         {
          title: "质量",
          key: "performance",
          align: "center"
        },
         {
          title: "评价",
          align: "center",
          slot:"maluation"
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
          width:150
        }
      ]
    };
  },
  methods:{
       changePage(p) {
        this.query.page = p;
        this.getList();
        },
      getList(){
          let _this=this;
          this.query.resourceId=this.id;
          console.log(this.query);
          project.rprojectList(this.query).then(res=>{
              _this.list=res.data.data;
              console.log(_this.list);
              _this.count=res.data.count;
          })
      },
      update(row){
        this.updateRProjectModal=true;
        this.projectId=row.id;
         this.$refs.projectInfo.setData(row);
      },
      saveRProject(){
         let _this=this;
         var data = this.$refs.projectInfo.getData();
         data.id=this.projectId;
         project
          .updateRProject(data)
          .then(res => {
            _this.getList();
            _this.$Message.success("保存成功");
            _this.addLoading = false;
            _this.updateRProjectModal = false;
          })
          .catch(err => {
            _this.$Message.error(err.response.data.message);
            _this.addLoading = false;
          });
      },
      deleteProject(row){
        let _this=this;
        this.$Modal.confirm({
          title:"是否删除该项目？",
          onOk:()=>{
             project.deleteRProject({id:row.id}).then(res=>{
            _this.$Message.success("删除成功");
             _this.getList();
        }) .catch(err => {
            _this.$Message.error(err.response.data.message);
          });
          }
        });
       
      }
  },
  mounted(){
      this.getList();
  }
};
</script>